
<h1>嵌入 PowerApps 应用示例</h1>
<iframe width="800" height="600" src="https://apps.powerapps.com/play/319509be-81a6-420d-b564-d3f47eb1e5cb?source=iframe&screenColor=rgba(165,34,55,1)" allow="geolocation; microphone; camera"></iframe>
